<template>
  <div class="container">
    <div class="row">
      <ChatBoosterTreinamento :modulos-conteudos="modulosConteudos"/>
    </div>
  </div>
</template>

<script>
import ChatBoosterTreinamento from '@/views/App/Treinamentos/Chat/ChatBoosterTreinamento.vue'

import {ModuloService} from '@/services/Modulo'

const moduloService = new ModuloService()

export default {
  components: {
    ChatBoosterTreinamento,
  },
  data() {
    return {
      modulosConteudos: {},
    }
  },
  computed: {
    idUser() {
      return JSON.parse(localStorage.getItem('userData')).id
    },
  },
  methods: {
    async getModulos() {
      await moduloService.getModuloConteudoById(153).then(response => {
        this.modulosConteudos = response
      })
    },
  },
  beforeMount() {
    this.modulosConteudos = {}
  },
  mounted() {
    this.getModulos()
  },
}
</script>
